<!--
 * @Author: Merlin
 * @Date: 2025-02-03 16:22:56
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-05 19:54:37
 * @Description:
    当服务器的 SSR 出错时，Nuxt 默认会显示本页 
    当前文件位置与文件名的现状，都是为了迎合 Nuxt 的默认设置 
-->

<template>
    <!-- ↓ 设定 name 穿上通用的外套 -->
    <NuxtLayout name="default">
        <div class="the-500-page">
            <Empty :content="' '" >
                <img class="pic w-[165px]" 
                    :src="oTheError?.statusCode == 404 ? pic404 : pic500"
                />
                <!-- <h3 class="code-title">
                    {{ oTheError.statusCode || 500 }}
                </h3> -->
                <p class="text">
                    {{ $t('commonInfo.error' )}}:
                    &nbsp;
                    {{ oTheError?.message || 'Unknown' }}
                </p>
                <div>
                    <span class="link"
                        @click="fnRefresh"
                        v-show="oTheError?.statusCode != 404"
                    >
                        <QIcon name="refresh" />
                        {{ $t('commonInfo.refresh') }}
                    </span>
                    &nbsp;
                    <span @click="fnGoHome" class="link">
                        <QIcon name="home" />
                        {{ $t('commonInfo.goHomePage') }}
                    </span>
                </div>
                <!-- ↓  -->
                <DevOnly>
                    <p class="text stack">
                        <br/>
                        <br/>
                        <br/>
                        Stack：(开发中可见)<br/> 
                        {{ oTheError?.stack || "无" }}
                    </p>
                </DevOnly>
            </Empty>
        </div>
    </NuxtLayout>
</template>

<script setup>
import { useLoadingStore } from '@/stores/loading';
import pic404 from '@/assets/imgs/status_404.webp';
import pic500 from '@/assets/imgs/status_500.webp';

// const props = defineProps({
//     error: {
//         type: Object,
//         default: () => ({}),
//     },
// });

const oTheError = useError() || {};
// console.log('error.stack: ', oTheError.value.stack.slice(0, 10)); 
const fnRefresh = ()=>{
    location.reload();
};

const fnGoHome = ()=>{
    const sPath = getLocalPath('/');
    // clearError({ redirect: sPath });
    location.href = sPath;
};


onMounted(()=>{
    const loadingStore = useLoadingStore();
    loadingStore.showLoading = false;
    loadingStore.gameLoading = false;
});
</script>

<style scoped lang="scss">
.the-500-page{
    padding-top: 10vh;
}
.code-title{
    font-size: 38px;
    font-weight: bold; 
    margin: 10px auto 00px;
}
.text{
    font-size: 14px;
    font-weight: 600; 
    margin: 00px auto 15px;
    color: var(--Text-Secondary);
    max-width: 88vw;
    word-break: break-all;
}

.text.stack{
    white-space: pre-line;
    word-break: break-all;
    opacity: 0.9;
}

.link{
    cursor: pointer;
    color: var(--Text-Secondary);
    .q-icon{
        font-size: 1.18em;
    }
}

</style>

